
/*
 * OPEN MODAL
 */
$('.forget_modal').click(function (e) {
    e.preventDefault();
    $('.ajax_response_forget').html("");
    openModal('#popup-forget');
});


$("#form_forget").submit(function (e) {
    e.preventDefault();
    var form = $(this);
    var flashClass = "ajax_response_forget";
    var flash = $("." + flashClass);

    form.ajaxSubmit({
        url: form.attr("action"),
        type: "POST",
        dataType: "json",
        beforeSend: function () {
            loaderShow();
        },
        success: function (response) {

            if (response.success) {
                flash.html(response.success).fadeIn(100);
            } else {
                //message
                if (response.message) {
                    if (flash.length) {
                        flash.html(response.message).fadeIn(100);
                    } else {
                        form.prepend("<div class='" + flashClass + "'>" + response.message + "</div>")
                            .find("." + flashClass);
                    }
                } else {
                    flash.fadeOut(100);
                }
            }

        },
        complete: function () {
            loaderClose();
            if (form.data("reset") === true) {
                form.trigger("reset");
            }
        }
    });
});



$("#form_emailregister").submit(function (e) {
    e.preventDefault();
    var form = $(this);
    var flashClass = "ajax_response_emailregister";
    var flash = $("." + flashClass);

    form.ajaxSubmit({
        url: form.attr("action"),
        type: "POST",
        dataType: "json",
        beforeSend: function () {
            loaderShow();
        },
        success: function (response) {

            //redirect
            if (response.redirect) {
                window.location.href = response.redirect;
            } else {
                loaderClose();
            }

            //message
            if (response.message) {
                if (flash.length) {
                    flash.html(response.message).fadeIn(100);
                } else {
                    form.prepend("<div class='" + flashClass + "'>" + response.message + "</div>")
                        .find("." + flashClass);
                }
            } else {
                flash.fadeOut(100);
            }

        },
        complete: function () {
            if (form.data("reset") === true) {
                form.trigger("reset");
            }
        }
    });
});
